import routes from 'agentRoutes';
import httpClient from 'agentHTTPClient';

import { ensureCart, fetchCart, selectFlightResultInMultiSearch, removeFromCart } from '../common';
import { fetchExchangeQuote } from './exchangeQuotes';

export const FLIGHT_SEARCH_RESULT_SELECTED = 'FLIGHT_SEARCH_RESULT_SELECTED';
function flightSearchResultSelected(result, searchId) {
  return {
    type: FLIGHT_SEARCH_RESULT_SELECTED,
    result,
    searchId,
  };
}

export const ADD_FLIGHT_TO_CART = 'ADD_FLIGHT_TO_CART';
export function addFlightToCart(
  cartId,
  id,
  searchParams,
  callbackParams,
  justification = null,
  canExchange = false,
) {
  return dispatch => {
    dispatch({ type: ADD_FLIGHT_TO_CART, id, searchParams });
    return httpClient
      .post(routes.api.carts.items.addFlight({ cartId }), {
        result_id: id,
        callback_params: callbackParams,
        justification,
        can_exchange: canExchange,
      })
      .then(({ data }) => data);
  };
}

export const STEP_SHOW_EXCHANGE_QUOTE = 'STEP_SHOW_EXCHANGE_QUOTE';
export const STEP_GO_TO_CART = 'STEP_GO_TO_CART';
export const STEP_CHOOSE_NEXT_RESULT = 'STEP_CHOOSE_NEXT_RESULT';

export const FARE_OPTION_SELECTED = 'FARE_OPTION_SELECTED';
export const FLIGHT_RESULT_SELECTED = 'FLIGHT_RESULT_SELECTED';
export const READY_FOR_CART = 'READY_FOR_CART';

export function selectFlightResult(searchId, matrix, result, tabKeyOfSelectedFairOption) {
  return (dispatch, getState) => {
    dispatch({
      type: FLIGHT_RESULT_SELECTED,
      result,
      matrix,
    });
    dispatch({
      type: FARE_OPTION_SELECTED,
      tabKeyOfSelectedFairOption,
    });
    const state = getState();

    const expectedSelectionCount =
      state.flights.searchParamsBySearchId[searchId] &&
      state.flights.searchParamsBySearchId[searchId].trips
        ? state.flights.searchParamsBySearchId[searchId].trips.length
        : 0;
    const selectedResults = state.flights.selectedResults;

    let selectedTripCount = 0;
    Object.values(selectedResults).forEach(selectedResult => {
      selectedTripCount += selectedResult.packageSize;
    });
    const selectionComplete = selectedTripCount === expectedSelectionCount;

    if (selectionComplete) {
      dispatch(flightSearchResultSelected(result, searchId));
      return Promise.resolve({ step: READY_FOR_CART, result });
    }
    return Promise.resolve({ step: STEP_CHOOSE_NEXT_RESULT });
  };
}

export function addFlightsFromResultToCart(
  searchId,
  deal,
  dealGroup,
  callbackParams,
  justification,
  canExchange,
  reservationItemIdentifier,
  unchangedTripIds,
) {
  return (dispatch, getState) => {
    const state = getState();
    const selectedResults = state.flights.selectedResults;
    const resultIds = Object.values(selectedResults).map(selectedResult => selectedResult.resultId);
    const existingCartItems = state.common.cart.items.map(({ id }) => id);

    const removeItemsPromise = canExchange
      ? Promise.all(existingCartItems.map(id => dispatch(removeFromCart(id, callbackParams))))
      : Promise.resolve();

    return removeItemsPromise
      .then(() => dispatch(ensureCart(callbackParams)))
      .then(cartId =>
        Promise.all(
          resultIds.map(id => {
            if (deal && dealGroup) {
              return dispatch(
                selectFlightResultInMultiSearch(dealGroup, id, searchId, callbackParams),
              );
            }
            const searchParams = state.flights.searchParamsBySearchId[searchId];

            return dispatch(
              addFlightToCart(cartId, id, searchParams, callbackParams, justification, canExchange),
            );
          }),
        ).then(() => {
          if (!deal || !dealGroup) {
            return dispatch(fetchCart(cartId, callbackParams)).then(() => {
              if (canExchange) {
                return dispatch(
                  fetchExchangeQuote(reservationItemIdentifier, resultIds[0], unchangedTripIds),
                ).then(isSuccess => {
                  if (isSuccess) {
                    return { step: STEP_GO_TO_CART, cartId };
                  }

                  return null;
                });
              }

              return { step: STEP_GO_TO_CART, cartId };
            });
          }

          return null;
        }),
      );
  };
}
